import React from 'react';
import BootstrapModal from 'react-bootstrap/Modal';
import { useDialogs } from '../../hooks';
import Component, { Content } from './Component';

export const ModalCompiler = ({ content, ...props }) => {
  return (
    <Modal {...props}>
      <Content content={content} />
    </Modal>
  );
};

export const Modal = ({ children, ...props }) => {
  const { dialogs = {}, hide } = useDialogs();
  const { [props.id]: dialog = {} } = dialogs;
  const { isShown = false } = dialog;

  const handleHide = () => {
    hide(props.id);
  };

  return (
    <Component
      {...props}
      show={isShown}
      onHide={handleHide}
      component={BootstrapModal}
    >
      {children}
    </Component>
  );
};

Modal.Body = BootstrapModal.Body;
Modal.Footer = BootstrapModal.Footer;
Modal.Header = BootstrapModal.Header;
Modal.Title = BootstrapModal.Title;

Modal.displayName = 'Modal';
ModalCompiler.displayName = 'Modal';
export default ModalCompiler;
